import { service, BASE_API } from '@/utils/request'
export default {
	getList(data) {
		return service ({
		  url: '/cloud/camp/admin/group-recommend/list',
		  method: 'get',
		  data
		})
	},
  doSave(data) {
	  return service({
      url: '/cloud/camp/admin/group-recommend',
      method: 'post',
      data
    })
  },
  doRemove(id) {
	  return service({
      url: '/cloud/camp/admin/group-recommend/' + id,
      method: 'delete'
    })
  },
  doUpdate(id, data) {
	  return service({
      url: '/cloud/camp/admin/group-recommend/' + id,
      method: 'PUT',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/operateManage/campRecommend.js